import { defineStore } from 'pinia'
import bettingserve from '@/services/bettingserve.js'

export const useWinBoostStore = defineStore('winboost', {
  state: () => ({
    configs: {
      status: 0,
      total_games: 0,
      odds_per_slip: 0,
      total_odds: 0,
      stake_range: [],
      excluded_markets: []
    },
    limits: {},
    configsLoaded: false,
    loading: false
  }),

  actions: {
    async fetchConfigs() {
      if (this.configsLoaded || this.loading) {
        return
      }

      this.loading = true

      try {
        const response = await bettingserve.get('/configs')
        if (response && response.status === 200) {
          this.configs = response.data.winboost
          this.limits = response.data.limits
          this.configsLoaded = true
        }
      } catch (error) {
        console.error('Failed to load win boost configs:', error)
      } finally {
        this.loading = false
      }
    }
  }
})
